module.exports = __webpack_public_path__ + "static/img/icon_used.185a7548.png";